import { ParentTable } from "./types/ParentTable";

export const SORT_ORDER_TABLES: { [tableName: string]: string } = {
	FeatureOutbuilding: "outbuildingSortOrder",
	MultifamilyUnit: "unitID",
	CommercialUnit: "unitID",
	MultifamilyUnitRoomType: "roomSortOrder",
	ParcelNumber: "sortOrder",
};

const MultifamilyUnitParentTable: ParentTable = {
	table: "MultifamilyUnit",
	skColumn: "multifamilyUnitSK",
	naturalKey: ["unitID"],
};

const FeatureOutbuildingParentTable: ParentTable = {
	table: "FeatureOutbuilding",
	skColumn: "featureOutbuildingSK",
	naturalKey: ["outbuildingSortOrder", "listingFeatureSK"],
};

export const PARENT_TABLES: { [tableName: string]: ParentTable } = {
	MultifamilyUnitAmenity: MultifamilyUnitParentTable,
	MultifamilyUnitAppliance: MultifamilyUnitParentTable,
	MultifamilyUnitBath: MultifamilyUnitParentTable,
	MultifamilyUnitCooling: MultifamilyUnitParentTable,
	MultifamilyUnitDiningRoom: MultifamilyUnitParentTable,
	MultifamilyUnitFamilyRoom: MultifamilyUnitParentTable,
	MultifamilyUnitFireplace: MultifamilyUnitParentTable,
	MultifamilyUnitRoomType: MultifamilyUnitParentTable,
	MultifamilyUnitSpecialSearch: MultifamilyUnitParentTable,
	OutbuildingFloor: FeatureOutbuildingParentTable,
	OutbuildingConstruction: FeatureOutbuildingParentTable,
};

export const CLEANUP_TABLES: ParentTable[] = [
	MultifamilyUnitParentTable,
	FeatureOutbuildingParentTable,
	{ table: "CommercialUnit", skColumn: "commercialUnitSK", naturalKey: null },
];

export const LOCKOXES_WITH_API = ["SentriLock", "Supra"];

export const ADBUILDER_BUTTON_TITLE = "Advertise this listing with AdBuilder™";
